module.exports = __webpack_public_path__ + "images/trial_banner/icon-trial-clock.png";